// Mock data for LoxitonDeepHouse Landing Page

export const heroSlides = [
  {
    id: 1,
    title: "MORENA THEDEEJAY",
    subtitle: "Moving Forward",
    description: "Never Give Up",
    image: "https://customer-assets.emergentagent.com/job_e4582f35-c8f2-4e4b-b7fd-194459bd68f8/artifacts/vj4y5q1q_Screenshot_20251210_133349.jpg",
    bgColor: "#151515",
    textColor: "#ffd1e7"
  },
  {
    id: 2,
    title: "NEW ALBUM",
    subtitle: "GRACE",
    description: "LoxitonDeepHouse Production",
    image: "https://customer-assets.emergentagent.com/job_e4582f35-c8f2-4e4b-b7fd-194459bd68f8/artifacts/mnz60q2x_Screenshot_20251125_142533.jpg",
    bgColor: "#0a0a0a",
    textColor: "#ff965a"
  },
  {
    id: 3,
    title: "LIVE SETS",
    subtitle: "Beach Vibes",
    description: "Bringing Deep House to Life",
    image: "https://customer-assets.emergentagent.com/job_e4582f35-c8f2-4e4b-b7fd-194459bd68f8/artifacts/xmmykajr_Screenshot_20251122_145203_edit_28299729234464.jpg",
    bgColor: "#1a1a2e",
    textColor: "#f6fd87"
  }
];

export const services = [
  {
    id: 1,
    title: "Music Production & Recording",
    description: "Professional production, mixing, mastering, and studio support for world-class Deep House tracks.",
    category: "Production",
    color: "#d987ff"
  },
  {
    id: 2,
    title: "Artist Management & Development",
    description: "Guiding artists through branding, sound improvement, and professional growth in the music industry.",
    category: "Management",
    color: "#88a2ff"
  },
  {
    id: 3,
    title: "Music Distribution",
    description: "Releasing music on global digital platforms including Spotify, Apple Music, TikTok Music, YouTube, and more.",
    category: "Distribution",
    color: "#f6fd87"
  },
  {
    id: 4,
    title: "Events & Live Performances",
    description: "Showcases, DJ sets, listening sessions, and branded events that bring the Deep House community together.",
    category: "Events",
    color: "#ff965a"
  },
  {
    id: 5,
    title: "Brand & Creative Direction",
    description: "Artwork, visual identity, promotional content, and brand alignment for artists on the roster.",
    category: "Creative",
    color: "#78d692"
  }
];

export const releases = [
  {
    id: 1,
    title: "GRACE",
    artist: "Morena TheDeeJay",
    type: "Album",
    year: "2025",
    image: "https://customer-assets.emergentagent.com/job_e4582f35-c8f2-4e4b-b7fd-194459bd68f8/artifacts/mnz60q2x_Screenshot_20251125_142533.jpg",
    color: "#ffd1e7",
    audiomackUrl: "https://audiomack.com/morena-thedeejay/album/loxitondeephouse?share-user-id=59239691"
  },
  {
    id: 2,
    title: "Only Lord",
    artist: "Morena TheDeeJay",
    type: "Single",
    year: "2025",
    image: "https://customer-assets.emergentagent.com/job_e4582f35-c8f2-4e4b-b7fd-194459bd68f8/artifacts/0qvt3udd_Screenshot_20251208_202547.jpg",
    color: "#b6cbcb",
    audiomackUrl: "https://audiomack.com/morena-thedeejay/album/only-lord?share-user-id=59239691"
  },
  {
    id: 3,
    title: "Never Give Up",
    artist: "Morena TheDeeJay",
    type: "EP",
    year: "2025",
    image: "https://customer-assets.emergentagent.com/job_e4582f35-c8f2-4e4b-b7fd-194459bd68f8/artifacts/vj4y5q1q_Screenshot_20251210_133349.jpg",
    color: "#d987ff",
    audiomackUrl: "https://audiomack.com/morena-thedeejay/album/never-give-up?share-user-id=59239691"
  }
];

export const coreValues = [
  { id: 1, title: "Creativity", description: "Pushing boundaries in sound and artistic expression." },
  { id: 2, title: "Authenticity", description: "Staying true to the roots and culture of Deep House." },
  { id: 3, title: "Excellence", description: "High-quality production standards in every release." },
  { id: 4, title: "Community", description: "Growing the Deep House movement in Africa and beyond." },
  { id: 5, title: "Growth", description: "Supporting the long-term success of every artist." }
];

export const contactInfo = {
  email: "info@loxitondeephouse.com",
  phone: "+27 61 483 6960",
  location: "Durban, South Africa",
  socials: {
    youtube: "https://youtube.com/@LoxitonDeepHouse",
    facebook: "https://facebook.com/LoxitonDeepHouse",
    instagram: "https://instagram.com/LoxitonDeepHouse",
    tiktok: "https://tiktok.com/@LoxitonDeepHouse",
    spotify: "https://open.spotify.com",
    audiomack: "https://audiomack.com/morena-thedeejay"
  }
};

export const brandInfo = {
  name: "LoxitonDeepHouse",
  slogan: "Bring music to life.",
  founder: "Morena TheDeeJay",
  logo: "https://customer-assets.emergentagent.com/job_e4582f35-c8f2-4e4b-b7fd-194459bd68f8/artifacts/87ns3p0w_Screenshot_20251119_114854_edit_81312388390699.jpg",
  djImage: "https://customer-assets.emergentagent.com/job_e4582f35-c8f2-4e4b-b7fd-194459bd68f8/artifacts/xmmykajr_Screenshot_20251122_145203_edit_28299729234464.jpg"
};
